import Link from "next/link";
import {
  getBlogHrefForAreaCode,
  getBlogLinkLabelForAreaCode,
} from "@/lib/areaCodeBlogLinks";

type AreaCodeBlogLinkProps = {
  code: string;
  className?: string;
};

export default function AreaCodeBlogLink({
  code,
  className = "font-bold text-harbor hover:underline",
}: AreaCodeBlogLinkProps) {
  const href = getBlogHrefForAreaCode(code);
  const label = getBlogLinkLabelForAreaCode(code) ?? `${code} area code`;

  if (!href) {
    return <span className="font-bold text-ink">{code}</span>;
  }

  return (
    <Link aria-label={label} className={className} href={href} title={label}>
      {code}
    </Link>
  );
}
